module.exports = __webpack_public_path__ + "static/media/Badge_SvgExpertCategoriel_CuirChevelu.153ee775.png";